export default {
    l_User_name: "Имя пользователя",
    l_User_password: "Пароль",
    l_Phone: "Телефон",
    l_Forgot_password: "Восстановить пароль",
    l_Login: "Войти",
    l_Sign_out: "Выход",
    l_EmailorPasswordisWrong: "Электронная почта или пароль неверны",
    l_User: "Пользователь",
    l_Payments: "Платежи",
    l_Promocodes: "Промокоды",
    l_Messages: "Сообщения",
    l_Consolidations: "Консолидации",
    l_Courier_Orders: "Заказы у курьера",
    l_Almaty: "Алматы",
    l_Name: "Название",
    l_Add: "Добавить",
    l_Action: "Действие",
    l_Total_weight: "Общий вес",
    l_Update: "Обновить",
    l_Edit: "Редактировать",
    l_Temu_return_back: "Вернуть на склад Temu",
    l_Submit: "Отправить",
    l_On_shelf: "На полке",
    l_Accepted_time: "Время принятия",
    l_Accepted_stationCode: "Филиал принятия",
    l_Remark_stationCode: "Пометивший филиал",
    l_Accepted_JPID: "JPID принявшего",
    l_Cancel: "Отмена",
    l_Remark_time: "Дата примечания",
    l_Remark_JPID: "JPID Пометившего",
    l_Are_you_sure_delete_this_task: "Вы уверены, что хотите удалить эту задачу?",
    l_Yes: "Да",
    l_Last_trackcodes: "Последние треки",
    l_Medium_batch_count: "Количестно medium count",
    l_No: "Нет",
    l_Tracking_number: "Номер отслеживания",
    l_Internal_Tracking_number: "Внутренний номер отслеживания",
    l_Actual_Price: "Фактическая цена",
    l_Estimated_price: "Расчетная цена",
    l_Actual_weight: "Фактический вес",
    l_kg: "кг",
    l_Estimated_weight: "Расчетный вес",
    l_Delivery_country: "Страна доставки",
    l_Delivery_type: "Тип доставки",
    l_Address: "Адрес",
    l_Execution_status: "Статус выполнения",
    l_Cargo: "Груз",
    l_Sign_up: "Зарегистрироваться",
    l_Next: "Далее",
    l_Verify_code: "Проверить код",
    l_Set_password: "Установить пароль",
    l_Confirm_password: "Подтвердите пароль",
    l_Get_SMS: "Получить SMS",
    l_Get_the_verification_code_first: "Сначала получите код подтверждения",
    l_Confirm_password_error: "Ошибка подтверждения пароля",
    l_Phone_number: "Номер телефона",
    l_Password: "Пароль",
    l_Wrong_password_format: "Неверный формат пароля",
    l_Please_enter_phone_number: "Пожалуйста, введите номер телефона",
    l_Please_enter_sms: "Пожалуйста, введите SMS",
    l_My_addresses: "Мои адреса",
    l_My_parcels: "Мои посылки",
    l_Buy_instead_of_me: "Купить вместо меня",
    l_Personal_data: "Личные данные",
    l_Update_password: "Обновить пароль",
    l_Old_Password: "Старый пароль",
    l_New_Password: "Новый пароль",
    l_Successed: "Успешно",
    l_Personal_information: "Личные данные",
    l_User_list: "Список пользователей",
    l_Email: "Электронная почта",
    l_Add_user: "Добавить пользователя",
    l_Full_name: "ФИО",
    l_IIN: "ИИН",
    l_ID_number: "Номер уд.личности",
    l_Issuing_authority: "Орган выдачи",
    l_Issue_date: "Дата выдачи",
    l_Validity: "Срок действия",
    l_Delivery_address: "Адрес доставки",
    l_Town: "Город/Район",
    l_Street: "Улица",
    l_House: "Дом",
    l_Postcode: "Почтовый индекс",
    l_Identity_card: "Удостоверение личности",
    l_Facial: "Лицевая",
    l_Negotiable: "Оборотная",
    l_Draw_a_signature: "Нарисуйте подпись",
    l_Or_download_the_signed_contract: "Или загрузите подписанный договор",
    l_Note: "Примечание",
    l_Precautions_for_uploading_pictures: "Прикрепляемый документ должен быть хорошего качества. Файл изображения не должен превышать 1 МБ.",
    l_Click_or_drag_ile_to_this_area_to_upload: "Нажмите или перетащите файл в эту область, чтобы загрузить",
    l_My_order: "Мой заказ",
    l_Track_code: "Трек-код",
    l_Recipient: "Получатель",
    l_Cargo_name: "Название груза",
    l_Declared_price: "Заявленная стоимость",
    l_Date: "Дата",
    l_Delivery_cost: "Стоимость доставки",
    l_Dispatch_country: "Страна отправки",
    l_Delivery_method: "Способ доставки",
    l_Order: "Заказ",
    l_Recipient_data: "Данные получателя",
    l_Shipping_country: "Страна доставки",
    l_Transportation_method: "Способ транспортировки",
    l_Price: "Цена",
    l_Quantity: "Количество",
    l_Total_cost: "Общая стоимость",
    l_Category: "Категория",
    l_Weapons_and_explosive_materials: "Оружие и взрывоопасные материалы",
    l_Alcoholic_drinks: "Алкогольные напитки",
    l_Sprays_and_aerosols: "Спреи и аэрозоли",
    l_Medicines_without_a_doctors_prescription: "Медикаменты без рецепта врача",
    l_radioactive_elements: "Радиоактивные элементы",
    l_Animals_and_plants: "Животные и растения",
    l_ALL_RIGHTS_RESERVED: "ВСЕ ПРАВА ЗАЩИЩЕНЫ",
    l_Contact: "Контакт",
    l_About_us: "О нас",
    l_The_shops: "Магазины",
    l_How_it_works: "Как это работает?",
    l_Rates: "Тарифы",
    l_Frequently_asked_Questions: "Часто задаваемые вопросы",
    l_Prohibited_Items: "Запрещенные предметы",
    l_Privacy_Policy: "Политика конфиденциальности",
    l_Weight: "Вес",
    l_Declaration: "Декларация",
    l_Pay: "Оплатить",
    l_Provinces: "Области",
    l_Country: "Страна",
    l_Full_address: "Полный адрес",
    l_MY_ADDRESS_IN_CHINA_FOR_AUTO_DELIVERY: "МОЙ АДРЕС В КИТАЕ ДЛЯ АВТО ДОСТАВКИ",
    l_Add_product: "Добавить груз",
    l_Please_enter_quantity: "Пожалуйста, введите количество",
    l_The_maximum_number_is: "The maximum number is",
    l_China: "Китай",
    l_Auto_delivery: "Авто доставка",
    l_To_avoid_problems_during_customs_clearance_please_enter_a_detailed_description_of_the_product_name_in_Russian: "Во избежание проблем при таможенном оформлении просьба указывать подробное описание наименования товара на русском языке.",
    l_Later_confirm: "Позже подтвердить",
    l_Confirm: "Подтвердить",
    l_Succeed: "Операция прошла успешно",
    l_Provide_a_link_to_the_product_we_will_buy_and_bring_it_for_you: "Отправьте ссылку на товар, мы купим и привезем его для вас!",
    l_Cargo_link: "Ссылка на груз",
    l_Additional_comment: "Дополнительный комментарий",
    l_Are_you_willing_to_buy_if_the_price_fluctuates_up_to_7: "Согласны ли вы на покупку, если цена колеблется до 7% ?",
    l_size: "Размер",
    l_Color: "Цвет",
    l_Delivery_price: "Цена за доставку",
    l_Promo_codes: "Промокоды",
    l_Whether_the_payment_is_completed: "Платеж завершен?",
    l_Completed: "Завершено",
    l_Not_completed: "Не завершено",
    l_Image_must_smaller_than_3MB: "Изображение должно быть меньше 3 МБ!",
    l_Image_must_smaller_than_2MB: "Image must smaller than 2MB!",
    l_Image_size_exceeds_5MB: "Размер изображения превышает максимум 5 МБ",
    l_Image_must_be_500x500: "Изображение должно быть 500x500",
    l_Image_format_error: "Ошибка формата изображения!",
    l_Analytics: "Аналитика",
    l_Status: "Статус",
    l_Order_id: "Идентификатор заказа",
    l_Traking_number: "Номер отслеживания",
    l_Amount: "Сумма",
    l_Payment_metehod: "Способ оплаты",
    l_Payment: "Платеж",
    l_Recipients: "Получатели",
    l_First_name: "Имя",
    l_Last_name: "Фамилия",
    l_Type: "Тип",
    l_Client: "Клиент",
    l_Admin: "Админ",
    l_Last_login: "Последний вход",
    l_Register: "Зарегистрироваться",
    l_Verified: "Проверено",
    l_Not_verified: "Проверка не удалась",
    l_All: "Все",
    l_Search: "Поиск",
    l_Statuses: "Статусы",
    l_Start_country: "Начальная страна",
    l_End_country: "Конечная страна",
    l_Sort: "Сортировать",
    l_Add_time: "Добавить время",
    l_Update_time: "Изменить время ",
    l_Ascending: "По возрастанию",
    l_Descending: "По убыванию",
    l_Create_time: "Время создания",
    l_Message: "Сообщение",
    l_Send_message: "Отправить сообщение",
    l_Internal_tracking_number: "Внутренний номер отслеживания",
    l_Shopping_instead: "Вместо этого покупки",
    l_Size: "Размер",
    l_Description: "Описание",
    l_Link: "Ссылка",
    l_City: "Город",
    l_All_cargo: "Все грузы",
    l_Volume: "Объем",
    l_Height: "Высота",
    l_Paid: "Оплачено",
    l_Unpaid: "Не оплачено",
    l_Declaration_verify: "Подтверждение декларации",
    l_Update_date: "Дата обновления",
    l_Add_date: "Добавить дату",
    l_Add_to_consolidation: "Добавить в консолидацию",
    l_Consolidation: "Консолидация",
    l_Consolidation_id: "Идентификатор консолидации",
    l_Add_type: "Добавить тип",
    l_Add_new: "Добавить новый",
    l_Contractor: "Подрядчик",
    l_Selected_order_quantity: "Выбранное количество заказа",
    l_Flight_number: "Номер рейса",
    l_Execution_date: "Дата выполнения",
    l_Document: "Документ",
    l_Add_order: "Добавить заказ",
    l_Can_choose_to_consolidation: "Может выбрать консолидацию",
    l_Amount_paid: "Выплаченная сумма",
    l_Payment_method: "Способ оплаты",
    l_Card: "Карта",
    l_Cash: "Наличные",
    l_External_ID: "Внешний идентификатор",
    l_Verification_succeeded: "Проверка прошла успешно",
    l_Verification_failed: "Проверка не удалась",
    l_Car_number: "Номер автомобиля",
    l_trailer_car_number: "Номер прицепа",
    l_Foreign_warehouse: "Зарубежный склад",
    l_Almaty_warehouse: "Алматинский склад",
    l_Info: "Информация",
    l_Payment_amount: "Сумма платежа",
    l_Automatic_storage_filter_cleared_when_refresh: "Автоматический фильтр хранения, очищается при обновлении",
    l_Not_found: "Не найдено",
    l_Contract_template: "Шаблон договора",
    l_File_format_error: "Ошибка формата файла!",
    l_Back_home_page: "Вернуться на главную страницу",
    l_Picked_up: "Получено",
    l_Not_picked_up: "Не получено",
    l_Payment_status: "Статус платежа",
    l_Ready_to_ship: "Готово к отправке",
    l_Belongs_category: "Принадлежит категории",
    l_File: "Файл",
    l_Poster: "Постер",
    l_format_error: "Ошибка формата",
    l_TN_CODE: "TNVED код ",
    l_Other: "Другое",
    l_Company: "Компания",
    l_Order_tracking: "Найти посылку",
    l_Not_fount: "Не найдено",
    l_Submit_and_print_label: "Отправить и label этикетку",
    l_Are_you_sure_update_password: "Вы уверены, что обновили пароль?",
    l_Print: "Печать",
    l_Operator: "Оператор",
    l_Russian_language: "Русский язык",
    l_Print_label: "Печать label",
    l_Warehouse: "Склад",
    l_Checking: "На рассмотрении",
    l_Verification_failed_description: "Причина неудачи проверки",
    l_App_version: "Версия приложения",
    l_App_version_title: "Название версии",
    l_App_version_content: "Содержимое версии",
    l_App_version_system: "Система приложений",
    l_Version: "Номер версии",
    l_Force_update: "Нужно принудительно обновить?",
    l_Published: "Опубликовано",
    l_Unpublished: "Не опубликовано",
    l_Select: "Выбрать",
    l_Gross_weight: "Вес брутто",
    l_Join_warehouse: "Добавить в склад",
    l_Batch_number: "Номер партии",
    l_Unclaimed_order: "Неполный заказ",
    l_China_batch: "CN batch",
    l_Reject_order: "Отклонить заказ",
    l_Mini_batch: "Мини batch",
    l_Kazakhstan_batch: "KZ batch",
    l_Branch_warehouse: "Филиал",
    l_Driver: "Драйвер",
    l_Dest_station: "Конечная станция",
    l_Batch: "Batch",
    l_Shelf: "Полка",
    l_Add_to_shelf: "Добавить на полку",
    l_Data: "Данные",
    l_Settings: "Настройки",
    l_Creator: "Создатель",
    l_Shelf_number: "Номер полки",
    l_Sorting_center: "Сортировочный центр",
    l_Pick_up: "Забрать",
    l_Scan: "Сканировать",
    l_Last_six_digits_of_mobile_number: "Последние шесть цифр номера мобильного телефона",
    l_Branch_batch: "Branch batch",
    l_Arrived_to_branch: "Прибыл в филиал",
    l_Arrived: "Прибыл",
    l_Export_excel: "Экспорт Excel",
    l_Work_time: "Рабочее время",
    l_Manager: "Менеджер",
    l_Province: "Провинция",
    l_Remark: "Примечание",
    l_Start: "Начало",
    l_End: "Конец",
    l_Do_not_add_randomly: "Не добавлять случайным образом!",
    l_Find_branch: "Проверить филиал",
    l_Refresh: "Обновить",
    l_Has_photo: "Есть фото",
    l_Valid_time: "Жарамды уақыты",
    l_Visible_state: "Видимое состояние",
    l_File_update_time: "Время обновления файла",
    l_Time: "Время",
    l_Created: "Создано",
    l_Group_payment: "Групповая оплата",
    l_Permission: "Разрешение",
    l_System: "Система",
    l_Info_api: "Инфо об API",
    l_Road_type: "Тип дороги",
    l_Official: "Официальный",
    l_Commerce: "Коммерция",
    l_Recommended_shelf: "Рекомендуемая полка",
    l_Amount_payable_by_the_client: "Сумма к оплате клиентом",
    l_Payment_completed: "Платеж выполнен",
    l_Error_batch: "Проблема с batch",
    l_Error_order: "Проблема с заказ",
    l_Error_mini_batch: "Проблема mini batch",
    l_Work: "Работа",
    l_China_logistics: "Логистика Китая",
    l_Receiver: "Получатель",
    l_Transport_day: "Дни на доставку",
    l_Day: "День",
    l_tel_merge: "Слияние телефонов",
    l_Abnormal_order: "Неправильный заказ",
    l_Customs: "Таможня",
    l_Contract: "Контракт",
    l_Invoice: "Invoice",
    l_Filter: "Фильтр",
    l_CN_category_id: "Идентификатор категории Китая",
    l_Prohibited_catgegories: "Запрещенные категории",
    l_Error: "Произошла техническая ошибка! Пожалуйста, пришлите скриншот в IT-отдел.",
    l_Those_whose_weight_is_over_31_kg: "Вес более 31 кг",
    l_The_price_is_more_than_1000: "Цена более 1000$",
    l_Price_over_1000_and_weight_over_31_kg: "Цена превышает 1000$ и весит более 31 кг",
    l_Net_weight: "Вес нетто",
    l_Overall_weight: "Общий вес",
    l_History: "История",
    l_Updated_time: "Время изменения",
    l_Order_count: "Количество заказов",
    l_Unknown: "Неизвестно",
    l_Mini_batch_count: "Количество mini batch",
    l_Return_order: "Возврат заказа",
    l_Change_branch: "Изменить филиал",
    l_Image: "Изображение",
    l_Search_in_shelf: "Искать на полке",
    l_Translation: "Перевод",
    l_Primary_language: "Основной язык",
    l_Content: "Содержание",
    l_Translated_language: "Переведенный язык",
    l_Check_the_category_of_KTZ: "Проверить категорию KTZ",
    l_There_is_KTZ_category: "Имеется категория KTZ",
    l_There_is_no_category_KTZ: "Категория KTZ отсутствует",
    l_Statistic: "Статистика",
    l_Are_you_sure_of_the_correctness_of_the_data: "Вы уверены в правильности данных?",
    l_China_warehouse: "Китайский склад",
    l_Sorting: "Сортировка",
    l_Role: "Роль",
    l_Stay_branch_day: "Дни нахождения в филиале (мин)",
    l_Min_weight: "Вес (мин)",
    l_Menu: "Меню",
    l_Left_from_Almaty: "Выехал из Алматы",
    l_Left_from_China: "Выехал из Китая",
    l_Almaty_warehouse_received: "Алматинский склад получил",
    l_China_warehouse_received: "Китайский склад получил",
    l_Jpid_build_by_minibatch: "Jpid, созданный minibatch",
    l_Weighed_id: "Взвешенный id",
    l_Close: "Закрыть",
    l_Article: "Статья",
    l_Employees: "Сотрудники",
    l_Visibility: "Видимость",
    l_Can_view: "Может увидеть",
    l_Admin_worker: "Рабочий администратор",
    l_Web: "Веб",
    l_General: "Общий",
    l_Door_to_door: "От двери до двери",
    l_Pending_orders: "ожидающие заказы",
    l_In_delivery: "доставка",
    l_Received: "получено",
    l_Reject: "Отклонить",
    l_Pending: "Ожидает",
    l_Supervision: "Супервизия",
    l_Language: "Язык",
    l_Agent: "Агент",
    l_My_Statistics: "Моя статистика",
    l_Count_Stats: "Статистика подсчета",
    l_Number_of_products_that_do_not_match_the_branch: "Количество товаров, не соответствующих филиалу",
    l_Quantity_of_goods: "Количество товаров",
    l_Batch_statistics: "Batch статистика",
    l_Returned_to_China_Courier: "Возвращен китайскому курьеру",
    l_Feedback: "Обратная связь",
    l_Accepted: "Принято",
    l_In_progress: "В процессе",
    l_Weight_change_history: "История изменения веса",
    l_Public_document: "Публичный документ",
    l_Recovery: "Восстановление",
    l_Logistic: "Логистика",
    l_Regional_center: "Региональный центр",
    l_Internal_logistics: "Внутренняя логистика",
    l_Branch: "Филиал",
    l_Dont_match: "Не совпадает",
    l_Additional_document: "Дополнительный документ",
    l_Additional_price: "Дополнительная цена",
    l_Weight_difference: "Разница веса",
    l_Dead_goods: "Мертвый товар",
    l_List: "Список",
    l_Result: "Результат",
    l_Reason: "Причина",
    l_Negotiate_order_prices: "Договориться о цене заказа",
    l_Negotiate_road_prices: "Договориться о ценах на дорогу",
    l_Bank_account: "Банковский счет",
    l_Finish: "Завершить",
    l_Revise: "Пересмотр",
    l_Alert_on_revision: "Время пересмотра не началось",
    l_Save: "Сохранить",
    l_Create: "Создать",
    l_Schedule: "Расписание",
    l_Coming: "В пути",
    l_Reception: "Прием",
    l_Put_on_the_shelf: "Положить на полку",
    l_Distribution: "Распространение",
    l_Result_status: "Статус результата",
    l_Tag: "Тег",
    l_Average_weight: "Средний вес",
    l_Dependent_region: "Зависимый регион",
    l_Reset_permission: "Сбросить разрешение",
    l_Cannot_be_deleted: "Невозможно удалить",
    l_Region: "Регион",
    l_Operator_statistic: "Статистика оператора",
    l_People_who_uploaded_the_document: "Люди, загрузившие документ",
    l_Reset: "Сброс",
    l_Rejected_order: "Отклоненный заказ",
    l_Warning_Has_an_impact_on_statistics: "Предупреждение! Есть влияние на статистику.",
    l_Fragile_products: "Хрупкие товары",
    l_Work_schedule: "График работы",
    l_Sorting_machine: "Сортировочное устройство",
    l_Unique: "Уникальный",
    l_Repeated: "Повторяющийся",
    l_Machine: "Аппарат",
    l_Ticket: "Билет",
    l_App_service: "App cервис",
    l_Badge: "Бейдж",
    l_Services: "Сервисы",
    l_Order_status: "Статус заказа",
    l_In_several_branches: "В нескольких филиалах",
    l_Not_in_database: "Нет в базе данных",
    l_Correct: "Правильно",
    l_Revision: "Ревизия",
    l_Detail: "Детали",
    l_Default: "По умолчанию",
    l_New: "Новый",
    l_Soon: "Скоро",
    l_Answer: "Ответ",
    l_Receive_client: "Получить от клиента",
    l_Work_order: "Рабочий порядок",
    l_Order_code: "Товар-код",
    l_Send_address: "Адрес отправки",
    l_Receive_name: "Имя получателя",
    l_Receive_contact: "Контакт получателя",
    l_Receive_address: "Адрес получателя",
    l_Express_Company_Id: "Идентификатор экспресс-компании",
    l_Express_Dealer: "Экспресс-доставщик",
    l_Express_Dealer_Contact: "Контакт Express доставщика",
    l_Compensate_Amount: "Сумма компенсации",
    l_Reply_type: "Тип ответа",
    l_Handle_result: "Обработать результат",
    l_Call_result: "Результат вызова",
    l_Pay_amount: "Цена товара",
    l_Compensate_state: "Статус компенсаций",
    l_sign_state: "Состояние подписи",
    l_Replied: "Ответил",
    l_Not_replied: "Не ответил",
    l_Orders_in_shelf: "Количество товаров на полке",
    l_Tariff: "Тариф",
    l_Filter_settings: "Настройка фильтров",
    l_PDD_received: "PDD получил",
    l_Wallet: "Кошелек",
    l_Bonus: "Бонус",
    l_Refund_account: "Ответственный за возврат",
    l_Duty: "Ответственная сторона",
    l_The_call_was_connected_but_there_was_no_response: "Вызов был подключен, но ответа не было",
    l_Wrong_number: "Неправильный номер",
    l_Phone_is_busy: "Телефон занят",
    l_No_response: "Нет ответа",
    l_Other_person: "Другой человек",
    l_By_default: "По умолчанию",
    l_Not_signed: "Не подписан",
    l_Signed: "Подписано",
    l_Cargo_company: "Грузовая компания",
    l_Seller: "Продавец",
    l_Will_not_compensate: "Не компенсируется",
    l_Will_compensate: "Компенсируется",
    l_Answered: "Кто ответил",
    l_Replied_at: "Время ответа",
    l_Consumer: "Клиент",
    l_Multi: "Мульти",
    l_Normal: "Нормально",
    l_Added_to_task: "Добавлено в задачу",
    l_Big_box: "Большая коробка",
    l_Task: "Задача",
    l_Has: "Есть",
    l_None: "Нет",
    l_All_answers: "Все ответы",
    l_Already_scanned: "Уже отсканировано!",
    l_Terminal: "Терминал",
    l_The_branch_does_not_match: "Филиал не соответствует",
    l_End_time: "Время окончания",
    l_Left: "Вышел",
    l_Reached_the_center: "Добрался до центра",
    l_Left_from_the_center: "Покинул центр",
    l_Scan_time: "Время сканирования",
    l_App_news: "Новости приложения",
    l_Title: "Заголовок",
    l_Check_list: "Проверочный список",
    l_Total_average: "Общий средний балл",
    l_Operation_JPID: "Операция JPID",
    l_Average_score: "Средний балл",
    l_Criteria_name: "Название критерия",
    l_Score: "Оценка",
    l_Check_list_add: "Добавить проверочный список",
    l_Criteria_add: "Добавить критерии",
    l_Checked_date: "Дата проверки",
    l_User_restore: "Восстановить пользователя",
    l_App_articles: "Статьи о приложении",
    l_Partner: "Партнер",
    l_News: "Новости",
    l_Lost: "Потерянный",
    l_Video: "Видео",
    l_Statement: "Заявление",
    l_Serve_speed: "Скорость отправки",
    l_Send_by_file: "Отправить через файл",
    l_Send_one: "Отправить поштучно",
    l_Late_goods: "Поздний товар",
    l_Warehouse_payment: "Складская оплата",
    l_Registration: "Регистрация",
    l_Questions: "Вопросы",
    l_Question: "Вопрос",
    l_Rating: "Оценки",
    l_Star: "Звездочка",
    l_Sender: "Отправитель",
    l_Rate_type: "Тип оценки",
    l_Rate_question: "Опрос оценки",
    l_Scan_with_app: "Просканируйте с помощью приложение Jana Post",
    l_Destroy: "Уничтожить",
    l_Sold: "Продано",
    l_Burned: "Сгорело",
    l_Rework: "Утилизация отходов",
    l_Worker: "Отправитель",
    l_Delivery: "Время выполнения",
    l_Send: "Отправить",
    l_Destroyed: "Уничтожено",
    l_File_must_be_less_than_5_MB: "Файл должен быть меньше 5 МБ!",
    l_Finish_sorting: "Завершить сортировку",
    l_Barcode: "Штрих-код",
    l_Inner_logistic_finish: "Внутренняя логистика закончилось",
    l_Table: "Стол",
    l_Charts: "Диаграммы",
    l_Option: "Вариант",
    l_Options: "Варианты",
    l_Results: "Итог",
    l_Partners: "Партнеры",
    l_Resume: "Резюме",
    l_Finance: "Финансы",
    l_Scanzona: "В зоне",
    l_Scanned_in_zona: "Отсканирован в зоне",
    l_Complaints: "Жалобы",
    l_Responsible_department: "Ответственный отдел",
    l_Partnership: "Партнерство",
    l_User_feedback: "Мнение пользователя",
    l_Recipient_stats: "Статистика получателей",
    l_Employee_discount: "Скидка для сотрудников",
    l_Transportation_time: "Время транспортировки",
    l_Hour: "Час",
    l_Add_filials: "Добавить филиалы",
    l_Filial_list: "Список филиалов",
    l_Count: "Доступное количество филиалов",
    l_Branches_for_partners: "Лист филиало для партнеров",
    l_Plomb: "Пломба",
    l_Latitude: "Широта",
    l_Longitude: " Долгота",
    l_By_file: "По файлу",
    l_By_filter: "По фильтру",
    l_User_count: "Количество пользователей",
    l_Fill_form: " Заполнение заявки",
    l_Open_your_own_branch: "Откройте свой филиал",
    l_Name_fill: " Имя Фамилия",
    l_individualEntrepreneur: "У вас есть действующий ИП",
    l_Address_link: "Введите ссылку из приложения 2ГИС на место, где вы хотите открыть отделение и напишите краткое описание с указанием квадратного метра.",
    l_Have_you_ordered: "Делали ли вы заказ через JANA POST? (нужно написать кJP код)",
    l_Address_fill: "Есть ли у вас место для открытия филиала, соответствующий требованиям JANA POST?",
    l_Based_on_your_current_location_are_you_in_Kazahstan: " Судя по вашему текущему местоположению, вы находитесь в Казахстане.",
    l_Based_on_your_current_location_are_you_in_Uzbekistan: " Судя по вашему текущему местоположению, вы находитесь в Узбекистане.",
    l_Based_on_your_current_location_are_you_in_Kyrgyzstan: "Судя по вашему текущему местоположению, вы находитесь в Кыргызстане.",
    l_Based_on_your_current_location_are_you_in_Tajikistan: "Судя по вашему текущему местоположению, вы находитесь в Таджикистане.",
    l_Based_on_your_current_location_are_you_in_Mongolia: "Судя по вашему текущему местоположению, вы находитесь в Монголии.",
    l_Continue: " Продолжать",
    l_Access_to_geodata_is_not_allowed: "Доступ к геоданным запрещен. Ваше местоположение не может быть определено",
    l_Location_information_is_unavailable: "Информация о местоположении отсутствует.",
    l_your_bday: "Дата рождения",
    l_knowledge: "Ваше образование",
    l_is_there_experience: "Есть ли у вас опыт управления бизнесом, управления людьми и организации?",
    l_is_there_2million: " У вас есть первоначальный взнос в размере 2 миллионов для открытия филиала?",
    l_Lower: "Cреднее специальное",
    l_Middle: "Среднее образование",
    l_Upper: "Высшее",
    l_Thanks: " Спасибо! Данные отправлены успешно. Наши менеджеры свяжутся с вами в ближайшее время",
    l_Did_already: "Вы уже заполнили опрос!",
    l_Communication: "Связаться",
    l_Area_covered: "Охваченная площадь",
    l_Document_service: "Служба документов",
    l_The_shelf_number_should_start_with_JP: "Номер полки должен начинаться с JP.",
    l_All_near_branches: "Все ближайшие филиалы",
    l_Important: "Важно",
    l_New_station: "Открытие новых филиалов",
    l_Branch_near_by: "Филиалы рядом",
    l_Branch_open_warehouse: "Все открытые филиалы",
    l_Need_branch: "Необходимо выбрать ветку",
    l_Daily_Count_Stats: "Ежедневная статистика",
    l_Agreement_branch: "Соглашение (Филиал)",
    l_Agreement_sign: "Подпись соглашение",
    l_Batch_not_installed: "Batch не установлен",
    l_Excel_print: "Вывести Excel (заказы)",
    l_Reading_list: "Список прочитавших",
    l_Marketing: "Маркетинг",
    l_Number: "Количество",
    l_Home_delivery: "Доставка на дом",
    l_Matching: "Сверка",
    l_Track_analytic: "Аналитика заказов",
    l_Call_center: "Call center",
    l_On_the_shelf: "Поставлено на полки",
    l_Delivered: "Доставлено",
    l_Available_offers: "Доступные предложения",
    l_Courier: "Курьер",
    l_Enabled: "Включено",
    l_Disabled: "Отключено",
    l_Identification_to_branch: "Идентификация филиала",
    l_Personal: "Личный",
    l_Finished_the_job: "Завершил работу",
    l_Completeness: "Целостность",
    l_Timeliness: "Своевременность",
    l_Timeliness_24h: "Своевременность 24 час",
    l_On_time_delivery: "Своевременная доставка",
    l_On_time: "Вовремя",
    l_Late: "Поздно",
    l_Total: "Всего",
    l_Percent: "В процентах",
    l_Margin: "Маржа",
    l_Loss: "Убыток",
    l_Income: "Доход",
    l_Today: "Сегодня",
    l_Yesterday: "Вчера",
    l_Day_before_yesterday: "Позавчера",
    l_Last_status: "Последний статус",
    l_Static_tracks: "Неподвижные заказы",
    l_Preparation_for_distribution: "Подготовка к раздаче",
    l_Mini_batch_destination: "Филиал принимающий M-Batch",
    l_Not_matched_stations: "Товары не соответстующие филиалу",
    l_Count_order_mbatch: "Количество товаров в M-Batch",
    l_No_branches_choosed: "Филиал не выбран",
    l_Agree_to_change_branches: "Согласившись с этим, вы измените филиал этого заказа на филиал, выбранную этим M-Btach",
    l_Change: "Поменять",
    l_Distribution_to_the_basket: "Распределение в корзину",
    l_Coordinate_status: "Статус координаты",
    l_Delivery_status: "Статус доставки",
    l_Number_of_baskets: "Число корзин",
    l_Basket_add: "Добавить в корзину",
    l_Basket_number: "Номер корзины",
    l_Courier_reseived: "Курьер получил",
    l_Courier_didnt_reseived: "Курьер не получил",
    l_Courier_jpcr: "Курьер JPCR",
    l_Need_to_scan_the_courier_JPCR: "Нужно сканировать JPCR курьера",
    l_Need_to_scan_the_basket_number: "Нужно сканировать номер корзины",
    l_First_scan_the_basket_number_to_check_the_status: "Сперва сканировав номер корзины, можно проверить статус",
    l_Last_time: "Последнее обновление",
    l_Clear: "Очистить",
    l_Basket_list: "Список корзин",
    l_Withdrawal_of_an_order: "Отозвание заказа",
    l_Basket: "Корзина",
    l_Adding_an_order_to_the_shelf: "Добавление заказа на полку",
    l_Distribution_of_the_order_in_the_basket: "Разделение заказа на корзину",
    l_Couriers: "Курьеры",
    l_To_divide_the_basket_you_need_to_add_the_order_to_the_shelf: "Для размещения заказа в корзине заказ должен быть добавлен на полку или статус доставки должен быть «Готовится размещение»!",
    l_Only_those_whose_coordinates_are_found_are_allocated_in_the_basket: "В корзину помещаются только те, чьи координаты найдены.",
    l_Orders_in_the_basket: "Заказы в корзине",
    l_Courier_refused: "Курьер отказал",
    l_Recommended_basket: "Рекомендуемая корзина",
    l_Number_of_goods_in_preparation_for_distribution: "Количество товаров, готовящихся к распределению",
    l_Frozen_state: "Замороженное состояние",
    l_Be_careful_when_freezing_the_order: "Будьте осторожны при замораживании заказа !",
    l_Branch_orders: "Заказы филиалов",
    l_Problem_description: "Описание проблемы",
    l_Go_to_website: "Перейти на сайт",
    l_Invite_list: "Список приглашённых",
    l_Inviter_JPID: "JPID пригласителя",
    l_Add_order_to_the_Basket: "Добавить заказ в корзину",
    l_Preparing_the_basket_in_the_order: "Подготовка заказа в корзину",
    l_Write_the_number_of_the_basket_where_the_orders_will_be_placed: "Напишите номер корзины, где будут размещаться заказы!",
    l_Order_withdrawal_from_courier: "Получение заказа у курьера",
    l_Distribution_of_the_order_to_the_courier_shelf: "Распределение заказа на курьерскую стойку",
    l_Courier_shelf_list: "Список курьерских полок",
    l_Orders_on_the_courier_shelf: "Заказы на полке курьера",
    l_Placing_the_order_on_the_courier_shelf: "Размещение заказа на полке курьера",
    l_Courier_shelf_number: "Номер курьерской полки",
    l_Preparing_the_order_for_the_courier_shelf: "Подготовка заказа на курьерскую полку",
    l_Adding_an_order_to_the_courier_shelf: "Добавление заказа на полку курьера",
    l_Place_on_the_courier_shelf: "Поместите на полку курьера",
    l_Allocation_to_the_courier_rack: "Размещение на курьерской стойке",
    l_Division_into_shelves: "Разделение на полку",
    l_Shipping_price: "Цена доставки",
    l_Cost_price: "Себестоимость",
    l_NORTH: "СЕВЕР",
    l_SOUTH: "ЮГ",
    l_WEST: "ЗАПАД",
    l_EAST: "ВОСТОК",
    l_Over45days: "Более 45 дней",
    l_Text: "Текст",
    l_Order_rectify: "Исправить товар",
    l_Not_received: "Не получено",
    l_Department: "Департамент",
    l_Operation_time: "Операционное время",
    l_Tracks: "Треки",
    l_Adding_a_courier_order: "Добавить заказ курьеру",
    l_Sending_to_courier: "Отправка курьеру",
    l_Regulation: "Управление",
    l_Orders_that_should_be_frozen: "Заказы, которые должны быть заморожены",
    l_On_the_courier: "У курьере",
    l_Goods_older_than_15_days: "Товары сроком годности более 15 дней",
    l_Frozen: "Замороженный",
    l_Late_delivered_orders: "Заказы, доставленные с опозданием",
    l_More_details: "Подробнее",
    l_Number_of_days: "Количество дней",
    l_Undelivered_goods: "Недоставленные заказы",
    l_Client_received: "Клиент получил",
    l_Stuck_orders: "Товары без движения",
    l_Check: "Проверить",
    l_District: "Район",
    l_Store: "Магазин",
    l_Route: "Рейс",
    l_Branch_batch_count: "Количество branch batch",
    l_Last_freeze_day: "Последний день заморозки",
    l_Level: "Уровень",
    l_Undelivered: "Недоставлено",
    l_New_user: "Новый пользователь",
    l_Sending_a_verification_code_to_the_client: "Отправка проверочного кода клиенту",
    l_Confirmation_code: "Код подтверждения",
    l_Transit_count: "Количество транзит",
    l_Wrong_tracks: "Неправильные треки",
    l_Normal_tracks: "Нормальные треки",
    l_Goods_lost_or_broken: "Товар потерян или сломан",
    l_Load_data: "Загрузить данные",
    l_China_storage: "Китайское хранилище",
    l_Inner_logistics: "Внутренняя логистика",
    l_Warning: "Предупреждение",
    l_Penalty: "Штраф",
    l_Day_left_to_return: "День до возврата",
    l_Reason_for_rejection: "Причина отказа",
    l_Rejection: "Отказ",
    l_DepartmentId: "Должник",
    l_Patronymic: "Отчество",
    l_Inviter: "Приглашающий",
    l_Awaiting_a_refund: "Ожидание возврата денег",
    l_Send_push_message: "Отправить push-сообщение",
    l_Order_search: "Поиск заказа",
    l_Exported: "В пути",
    l_Arrival_transfer_center: "Станция (Хоргос)",
    l_Export_clearance_start: "Начало таможенного оформления экспорта",
    l_Export_clearance_finish: "Окончание экспортного оформления",
    l_Departure_foreign: "Выезд за границу",
    l_Reached_Kazakhstan: "Достиг Казахстана",
    l_Import_clearance_start: "Начало таможенного оформления импорта",
    l_Import_clearance_finish: "Таможенное оформление импорта заканчивается",
    l_Package_status: "Статус посылки",
    l_Arrival_branch: "Прибытие в пункт выдачи",
    l_KZ_mini_batch_products: "Товар в KZ mini batch",
    l_Scanned: "Сканирован",
    l_More: "Больше",
    l_Chinese_address: "Китайский адрес",
    l_Fill_in_the_information: "Заполните информацию",
    l_Day_delivered: "дней доставлено",
    l_Day_delivering: "дней доставляется",
    l_Client_address: "Адрес клиента",
    l_Warehouse_address: "Адрес склада",
    l_Domestic_Express__Affordable_Prices: "Внутренний экспресс",
    l_Resubmit: "Отправить снова",
    l_Add_language: "Добавить язык",
    l_Create_discount: "Создать скидку",
    l_Please_enter_jpid: "Введите JPID",
    l_Video_guide: "Видео-инструкция",
    l_Max_upload_weight: "Максимальный размер — {size}",
    l_Story_feed: "Лента историй",
    l_Story: "История",
    l_Media: "Медиа",
    l_Button: "Кнопка",
    l_Marketplace: "Маркетплейс",
    l_China_warehouse_address: "Адрес склада в Китае",
    l_After_copy_url: "URL после копирования",
    l_Confirm_action: "Подтвердите действие.",
    l_VIP_client: "VIP-клиент",
    l_Notification: "Уведомление",
    l_Back_to_school: "Back to school",
    l_Categories: "Категории",
    l_Add_category: "Добавить категорию",
    l_Add_subcategory: "Добавить подкатегорию",
    l_Subcategory: "Подкатегория",
    l_Hidden: "Скрыт",
    l_Products: "Товары",
    l_Add_bts_product: "Добавить товар",
    l_Product_link: "Ссылка на товар",
    l_Horizontal_placement: "Помещается горизонтально",
    l_Limit: "Лимит",
    l_Characters: "символов",
    l_Enter_https_url: "Введите корректный https URL",
    l_Push_category: "Push категория",
    l_By_category: "По категориям",
    l_Min_count_required: "Должно быть минимум {count} {element}",
    l_Max_count_allowed: "Максимум {count} {element}",
    l_Only_latin_letters_allowed: "Только латиница, цифры, “-”, “_”",
    l_Error_500: "Внутренняя ошибка сервера. Попробуйте позже.",
    l_Janapost_link: "Ссылка JanaPost",
    l_Internal_link: "Внутренняя ссылка",
    l_Shared_link: "Общая ссылка",
    l_Upload_video: "Загрузить видео",
    l_Enter_link: "Ввести ссылку",
    l_External_link: "Внешняя ссылка",
    l_Buttons: "Кнопки",
    l_Add_Image_and_buttons: "Добавить изображение и кнопки",
    l_Free_delivery: "Бесплатная доставка",
    l_Statistics: "Статистика",
    l_Mastercard_payments: "Платежи по Mastercard",
    l_Total_payment_amount: "Сумма платежа",
    l_Promotion_amount: "Сумма со скидкой",
    l_Total_payment_count: "Количество платежей",
    l_Total_unique_users: "Количество уникальных пользователей",
    l_Please_fill_in_this_field: "Просим вас заполнить это поле",
    l_Deleted_accounts: "Удаленные аккаунты",
    l_Context: "Контекст",
    l_Reasons_for_account_deletion: "Причина удаления аккаунта",
    l_Client_type: "Тип клиента",
    l_Client_filter: "Фильтр клиентов",
    l_By_has_order: "По наличию заказов",
    l_By_the_order_time: "По времени заказа",
    l_Push_send_confirm: "Сообщение будет отправлено {count} пользователям! Количество верное?",
    l_Has_order_yes: "Есть заказы",
    l_Has_order_no: "Нету заказов",
    l_Select_has_order: "Выберите наличие заказа",
    l_Select_order_time: "Выберите время заказа",
    l_Stories: "Сторисы",
    l_Stories_banner_statistics: "Статистика сторисов",
    l_Max_day_count: "Допустимый временной диапазон: {count} дней",
    l_Error_occured: "Произошла ошибка. Попробуйте позже.",
    l_Promo_code: "Промокод",
    l_Common: "Общее",
    l_System_send: "Системная отправка",
    l_Enter_promo_code: "Введите промокод / JPID / номер телефона",
    l_Owner: "Владелец",
    l_Bonus_discount: "Бонус / Скидка",
    l_Enter_bonus_amount: "Введите сумму бонуса",
    l_Usage_count: "Количество использований",
    l_Expiration_date: "Дата окончания",
    l_Enter_expiration_date: "Введите дату окончания",
    l_Active: "Активен",
    l_Inactive: "Неактивен",
    l_Expired: "Истекло",
    l_View: "Просмотр",
    l_Disable: "Сөндіру",
    l_Platform: "Платформа",
    l_Device: "Устройство",
    l_Conversion: "Конверсия",
    l_Earned_bonus: "Заработанные бонусы",
    l_Burned_bonus: "Сгоревшие бонусы",
    l_System_promo_code: "Системный промокод",
    l_Distribution_channels: "Каналы рассылки",
    l_Enter_description: "Введите описание / дополнительную информацию",
    l_Select_at_least_one_distribution_channels: "Выберите как минимум один канал рассылки",
    l_Old_first: "Сначала старые",
    l_New_first: "Сначала новые",
    l_User_promo_code: "Промокод пользователя",
    l_Enter_title_in_ru: "Введите название на русском языке",
    l_Enter_title_in_kk: "Введите название на казахском языке",
    l_Enter_description_in_ru: "Введите описание на русском языке",
    l_Enter_description_in_kk: "Введите описание на казахском языке",
    l_Send_count: "Количество отправленных",
    l_Expired_count: "Количество истекших",
    l_Used_amount: "Сумма использованных",
    l_Expired_amount: "Сумма истекших",
    l_Date_type: "Тип даты",
    l_Period: "Период",
    l_Are_you_sure_to_off_promocode: "Вы точно хотите деактивировать промокод?",
    l_Are_you_sure_to_on_promocode: "Вы точно хотите активировать промокод?",
    l_Please_fill_all_fields: "Пожалуйста, заполните все поля",
    l_Please_select_a_promo_code: "Пожалуйста, выберите промокод",
    l_Are_you_sure_in_filled_fields: "Вы уверены в правильности заполненных полей?",
    l_Last_usage_time: "Последнее использование",
    l_Loading: "Загружается, просим подождать...",
    l_Kazakhstan: "Казахстан",
    l_Kyrgyzstan: "Киргизия",
    l_Uzbekistan: "Узбекистан",
    l_Tajikistan: "Таджикистан",
    l_Mongolia: "Монголия",
    l_Promo_disabled: "Промокод успешно деактивирован",
    l_Promo_enabled: "Промокод успешно активирован",
    l_Field_cannot_be_empty: "Поле не может быть пустым",
    l_Push_sent_successfully: "Push-уведомление успешно отправлено",
    l_Successfully_updated: "Успешно обновлено",
    l_Kazakh: "На казахском",
    l_Russian: "На русском",
    l_English: "На английском",
    l_Currency: "Валюта",
    l_Select_currency: "Выберите валюту",
    l_Successfully_created: "Успешно создано",
    l_Something_went_wrong: "Произошла ошибка. Попробуйте позже.",
    l_Must_be_more_than_zero: "Значение должно быть больше нуля",
    l_User_send_count: "Количество отправленных",
    l_Active_time: "Время активности",
    l_For_one_promocode: "Один промокод",
    l_Promocode_expired: "Срок действия промокода истек",
    l_By_days: "Через дни",
    l_By_exact_date: "Точная дата",
    l_Enter_days: "Введите количество дней от сегодняшнего дня",
    l_Please_wait_seconds: "Просим ожидать несколько секунд.",
    l_This_sign_is_not_allowed: "Этот знак не разрешен",
    l_Promo_code_title: "Название промокода",
    l_Redemption_policy: "Правила использования промокода",
    l_Standard: "Стандарт",
    l_Single_use_burn_remainder: "Однократное использование (остаток сгорает)",
    l_Select_redemption_policy: "Выберите правила использования промокода",
    l_Enter_promo_code_only: "Введите название промокода",
    l_Remote_config: "Remote config",
    l_Remote_config_info: "Информация",
    l_Remote_config_social: "Соцсети",
    l_Remote_config_legal: "Юридические документы",
    l_Remote_config_features: "Функции",
    l_Remote_config_devmode: "Тестовый режим",
    l_Remote_config_home_page_promo_icon: "BTS config",
    l_Remote_config_image_url: "URL изображения",
    l_Remote_config_general: "Общее",
    l_Remote_config_bin: "БИН",
    l_Remote_config_about_app: "О приложении",
    l_Remote_config_search_url: "URL поиска",
    l_Remote_config_contact: "Контакты",
    l_Remote_config_feedback_email: "Email обратной связи",
    l_Remote_config_feedback_url: "URL обратной связи",
    l_Remote_config_support_service: "Служба поддержки",
    l_Remote_config_app_url: "App URL (deeplink)",
    l_Remote_config_web_url: "Web URL",
    l_Remote_config_public_contract: "Публичный договор",
    l_Remote_config_agreement: "Соглашение",
    l_Remote_config_tracking_numbers: "Тестовые трекинг-номера",
    l_Remote_config_social_facebook: "Facebook",
    l_Remote_config_social_instagram: "Instagram",
    l_Remote_config_social_tiktok: "TikTok",
    l_Remote_config_social_youtube: "YouTube",
    l_Remote_config_social_telegram: "Telegram",
    l_Remote_config_social_whatsapp: "WhatsApp",
    l_Remote_config_feature_education: "Обучение",
    l_Remote_config_feature_domestic: "Внутренние доставки",
    l_Remote_config_feature_addOrder: "Добавление посылки",
    l_Remote_config_feature_inviteFriend: "Пригласить друга",
    l_Remote_config_feature_copyAddress: "Копирование адреса",
    l_Delete: "Удалить",
    l_Value: "Значение",
    l_Home_banner: "Баннер",
    l_Add_home_banner: "Добавить баннер",
    l_Update_home_banner: "Обновить баннер",
    l_Show_period: "Период показа",
    l_Show_period_hint: "Введите период показа",
    l_No_period_limit: "Без ограничения периода",
    l_Views: "Просмотры",
    l_Clicks: "Клики",
    l_Statistics_update_hint: "Статистика обновляется раз в сутки",
    l_Manage_order: "Управление порядком",
    l_Url: "Внешняя ссылка",
    l_App_section: "Раздел приложения",
    l_Show_from: "Показать с",
    l_Show_to: "Показать до",
    l_Enter_sort_number: "Введите номер сортировки",
    l_Preview: "Превью",
    l_Select_language_to_reorder: "Выберите язык для изменения порядка",
    l_No_data: "Нет данных",
    l_End_time_cannot_be_in_past: "Дата окончания не может быть в прошлом",
    l_Active_now: "Активен сейчас",
    l_Scheduled: "Запланирован",
    l_Copied: "Скопировано",
    l_New_version_logo: "Новая лого",
    l_New_version_video: "Видео новой версии",
    l_Until: "До {time}",
    l_From: "С {time}",
    l_How_to_fill_link_field: "Как заполнять поле со ссылкой",
    l_Opens_screen_inside_app: "открывает экран внутри приложения.",
    l_Allowed_values: "Допустимые значения",
    l_Unknown_module_banner_not_open: "Любое другое значение — баннер не будет открываться.",
    l_Opens_external_link_examples: "открывает внешнюю ссылку. Примеры",
    l_Website: "Сайт",
    l_App_not_installed_web_fallback: "Если приложение (WhatsApp, Telegram и т.д.) не установлено — автоматически откроется веб-версия.",
    l_Branches: "Отделения",
    l_Pickup: "Pickup-страница",
    l_Enter_valid_link: "Введите корректную ссылку (https://... или deep link)",
    l_Module_value_type: "Что открыть",
    l_From_list: "Раздел из списка",
    l_Banner_link_help_title: "Что произойдёт при нажатии на баннер",
    l_Help_url_desc: "откроет внешнюю ссылку в браузере или в приложении. Примеры:",
    l_Help_module_desc: "откроет контент внутри нашего приложения. Два варианта:",
    l_Help_module_list_desc: "откроет готовый экран (Jana Drive, Отделения, FAQ и т.д.)",
    l_Help_module_url_desc: "откроет ссылку внутри приложения (WebView), без перехода в браузер",
    l_Url_short: "Ссылка",
    l_Help_module_only_five_note: "Пока доступно только 5 разделов из выборов: Jana Drive, Отделения, FAQ, Pickup, Настройки. К остальным разделам нужно будет привязывать через ссылку. Чтобы привязать баннер к другому разделу рекомендуем сначала уточнить точный путь.",
    l_Information_block_banner: "Рекомендуемая информация перед использованием",
    l_Required_field: "Обязательное поле",
    l_Change_history: "История изменений",
    l_Updated_by: "Кем изменён",
    l_History_create: "Создан",
    l_History_update: "Изменён",
    l_History_enable: "Включён",
    l_History_disable: "Выключен",
    l_History_delete: "Удалён",
    l_Home_page: "Главная",
    l_Promocode_actions: "Промокод акции",
    l_Export_to_excel: "Excel",
    l_Create_promo_action: "Создать акцию",
    l_Search_by_promocode: "Поиск по промокоду",
    l_Enter_promocode: "Введите промокод",
    l_Promo_action_name: "Название акции",
    l_Bonus_amount: "Сумма бонуса",
    l_Period_range: "Период",
    l_Used_count: "Применений",
    l_Promo_finished: "Завершён",
    l_Promo_stopped: "Остановлена",
    l_Total_records: "Всего {count} записей",
    l_Per_page: "стр",
    l_Country_label: "Страна",
    l_Url_example: "Если нужно показать страницу приложения, то введите jana_webview:https://...",
    l_Please_enter_full_name: "Введите полное имя",
    l_Please_enter_email: "Введите почту",
    l_Please_enter_valid_email: "Введите корректную почту",
    l_Archive: "Архив",
    l_Archived_promo_actions: "Архивированные промокод-акции",
    l_Back_to_promo_actions: "Вернуться к промокод-акциям",
    l_Archived_date: "Дата архивации",
    l_Make_copy: "Создать копию",
    l_Restore: "Вернуть",
    l_Export_to_excel_v2: "Выгрузить в Excel",
    l_Choose: "Выбрать",
    l_Choose_country: "Выберите страну",
    l_General_section: "Общее",
    l_Enter_promo_name: "Введите название акции",
    l_Enter_bonus: "Введите сумму бонуса",
    l_Promocode_conditions: "Условия начисления",
    l_Immediately_after_code: "После ввода кода",
    l_After_order: "После заказа",
    l_Order_type: "Тип заказа",
    l_Order_status_paid: "Оплаченный",
    l_Order_status_delivered: "Доставленный",
    l_Which_order_counts: "Учитывать заказ",
    l_First_order: "Первый заказ",
    l_Any_order: "Любой заказ",
    l_Select_placeholder: "Выберите значение",
    l_Period_and_limits: "Срок действия и лимиты",
    l_Start_date: "Начало",
    l_End_date: "Окончание",
    l_Select_date: "Выберите дату",
    l_Unlimited: "Бессрочно",
    l_Bonus_lifetime_days: "Дней жизни бонуса",
    l_Enter_days_placeholder: "Введите количество дней",
    l_Participant_limit: "Лимит участников",
    l_Enter_limit: "Введите лимит участников",
    l_Max_bonus_share: "Максимальная доля оплаты бонусом",
    l_Enter_percent: "Введите значение",
    l_Percent_of_order_amount: "от суммы заказа",
    l_Notification_texts: "Тексты уведомлений",
    l_Enter_notification_text: "Введите текст уведомления",
    l_Draft_not_active: "Черновик • не активна",
    l_Save_changes: "Сохранить изменения",
    l_Launch_action: "Запустить акцию",
    l_Changes_saved: "Изменения сохранены",
    l_Promo_action_launched: "Акция запущена",
    l_Duplicate_action: "Копировать акцию",
    l_Edit_info: "Редактировать информацию",
    l_Pause_action: "Приостановить акцию",
    l_Stop_early: "Остановить досрочно",
    l_Send_to_archive: "Отправить в архив",
    l_Action_period: "Период акции",
    l_Bonus_condition: "Условие бонуса",
    l_Calculated_bonus: "Начисленный бонус",
    l_Bonus_usage_rate: "Уровень использования бонусов",
    l_Active_period_left: "Активный период",
    l_Avg_daily_spend: "Средний дневной расход",
    l_Day_short: "день",
    l_Awaiting_condition: "Ожидают выполнения условия",
    l_Conversion_funnel: "Воронка конверсии",
    l_Funnel_code_entered: "Ввели код",
    l_Funnel_condition_fulfilled: "Условие выполнено",
    l_Funnel_bonus_used: "Использовали бонус",
    l_Funnel_bonus_burned: "Бонус сгорел неиспользованным",
    l_Bonus_status: "Статус бонусов",
    l_Bonus_status_unused: "Не использован",
    l_Bonus_status_spent: "Потрачен",
    l_Bonus_status_burned: "Сгорел",
    l_Bonus_status_returned: "Возвращён",
    l_Usage_list: "Список применений",
    l_Usage_pending: "Ожидает",
    l_Usage_completed: "Выполнено",
    l_Usage_returned: "Возвращено",
    l_Search_by_phone: "Поиск по номеру телефона",
    l_Filters: "Фильтры",
    l_Client_phone: "Клиент (телефон)",
    l_Used_at: "Время применения",
    l_Calculated: "Начислено",
    l_Expire_date: "Дата сгорания",
    l_Order_number: "№ заказа",
    l_Active_tab: "Активные",
    l_Archive_tab: "Архив",
    l_Search_promocode_or_name: "Введите промокод / название акции",
    l_Was_sent_to_archive: "Промокодная акция отправлена в архив",
    l_New_promo_code: "Новый промокод",
    l_Edit_promo_code: "Редактирование промокода",
    l_Duplicate_promo_code: "Дублирование промокода",
    l_Restart_promo_code: "Перезапуск промокода",
    l_Balance_carries_over: "Остаток на счет",
    l_Balance_burns_out: "Остаток сгорает",
    l_Order_conditions: "Условия заказа",
    l_Usage_conditions: "Условия использования",
    l_No_limit: "Без ограничения",
    l_No_end_date: "Без даты окончания",
    l_Order_status_paid_desc: "бонус после оплаты",
    l_Order_status_delivered_desc: "бонус после доставки",
    l_First_order_desc: "первый заказ",
    l_Any_order_desc: "любой заказ",
    l_Applied_count: "Применений",
    l_Ordered_count: "Сделали заказ",
    l_Accrued: "Начислено",
    l_Kg_short: "кг",
    l_Condition_fulfilled: "условие выполнено",
    l_By_orders_with_promo: "по заказам с промокодом",
    l_Applied_to_order: "применение → заказ",
    l_Bonus_sum: "сумма бонусов",
    l_Spent: "Потрачено",
    l_Written_off_in_orders: "списано в заказах",
    l_By_lifetime: "по сроку жизни",
    l_Returned: "Отозвано",
    l_Order_cancellations: "отмены заказов",
    l_Actions: "Действия",
    l_Funnel_accrued: "Начислено",
    l_Funnel_bonus_spent: "Потратили бонус",
    l_Funnel_burned_without_spend: "Сгорело без траты",
    l_Applied_at: "Применен",
    l_Applied_date: "Дата применения",
    l_Date_expired: "Истекло",
    l_Unlimited_v2: "Без лимита",
    l_Condition: "Условие",
    l_Accrual_after_warehouse: "После доставки в склад",
    l_Accrual_after_payment: "После оплаты",
    l_Accrual_immediate: "Поступает сразу",
    l_Restart: "Перезапустить",
    l_Restore_from_archive: "Восстановить из архива",
    l_Standard_desc: "Остаток на счет",
    l_Single_use_remainder_desc: "Остаток сгорает",
    l_Choose_status: "Выберите статус",
    l_Launch_now: "Включить",
    l_Duplicate: "Дублировать",
    l_Action_not_configured: "Действие не настроено",
    l_Stopped: "Остановлено",
    l_Resume_v2: "Возобновить",
    l_Resumed: "Возобновлено",
    l_Restored_from_archive: "Восстановлено из архива",
    l_Stop: "Остановить",
    l_Promo_details: "Детали промокода",
    l_Days_short: "дн.",
    l_Remote_config_custom_order: "Добавление заказа",
    l_Select_country: "Выберите страну",
    l_All_countries_added: "Все страны добавлены",
    l_Feature_flags: "Функциональные флаги",
    l_Control_groups: "Группы пользователей",
    l_Show_to_all: "Видна всем",
    l_Show_to_group: "Видна для группы",
    l_Show_by_conditions: "Видна по условиям",
    l_Countries: "Страны",
    l_Add_country: "Добавить страну",
    l_Station_code_prefixes: "Префиксы кодов филиалов",
    l_Enter_station_code_prefixes: "Введите префиксы, например JP02",
    l_Station_code_prefixes_hint: "Код домашней станции пользователя должен начинаться с одного из префиксов",
    l_Conditions: "Условия",
    l_Group_or_users_required: "Выберите группу или введите хотя бы одного пользователя",
    l_Country_or_station_prefix_required: "Выберите страну или введите хотя бы один префикс филиала",
    l_Code: "Код",
    l_Enter_title: "Введите заголовок",
    l_Enter_code: "Введите код",
    l_Select_group: "Выберите группу",
    l_Users_list: "Список пользователей",
    l_Enter_users: "Введите пользователей",
    l_Users_count: "Количество пользователей",
    l_Badges: "Значки",
    l_Not_set: "Не установлено",
    l_Text_color: "Цвет текста",
    l_Background_color: "Цвет background-а",
    l_Approximate: "Примерное",
    l_Logo: "Логотип",
    l_Enter_marketplace: "Введите маркетплейс",
    l_Chapters: "Главы",
    l_No_chapters: "Нет глав",
    l_Add_chapter: "Добавить главу",
    l_Chapter_name: "Название главы",
    l_Required: "Обязательное поле",
    l_Start_seconds: "Начало (секунды)",
    l_Duplicate_chapter_start_time: "Две главы не могут начинаться в одну и ту же секунду",
    l_Video_timeline: "Видео TimeLine",
    l_Fill_all_notification_texts: "Заполните все тексты уведомлений",
    l_Field_required: "Поле необходимо заполнить",
    l_Restart_action: "Перезапустить",
    l_Promo_action_restarted: "Промокод перезапущен",
    l_Fill_required_fields: "Заполните все обязательные поля",
    l_Use_second_page_to_add_promocode: "Для добавления промокода используйте вторую страницу (v2)",
}
